import React, { useEffect, useState } from "react";
import { BrowserRouter, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import Tickets from "../pages/Tickets/";
import Signup from "../pages/Signup/";
import Login from "../pages/Login/";
import Connections from "../pages/Connections/";
import Settings from "../pages/Settings/";
import Clients from "../pages/Clients";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import QuickAnswers from "../pages/QuickAnswers/";
import Queues from "../pages/Queues/";
import PublicCatalog from "../pages/PublicCatalog";
import { AuthProvider } from "../context/Auth/AuthContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import { ThemeProvider } from "../context/DarkMode";
import Route from "./Route";
import Statistics from "../pages/Statistics/";
import Catalog from "../pages/Catalog";
import api from "../services/api";
import toastError from "../errors/toastError";
import publicApi from "../services/publicApi";

const Routes = () => {
  const [settings, setSettings] = useState([]);
  const [storeEnabled, setStoreEnabled] = useState(true);
  useEffect(() => {
    const fetchSession = async () => {
      try {
        const { data } = await publicApi.get("/settings");
        setSettings(data);
        const setting = settings.find(s => s.key === "storeEnabled");
        if (setting) {
          setStoreEnabled(setting.value === "enabled");
        }

      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, []);
  const getSettingValue = key => {
    const setting = settings.find(s => s.key === key);
    return setting ? setting.value : "";
  };
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <Switch>
            {/* Public catalog route */}
            {storeEnabled && (
              <Route exact path="/catalog/public" component={PublicCatalog} isPublic />)}
            {/* Auth routes */}
            <Route exact path="/login" component={Login} />
            <Route exact path="/signup" component={Signup} />

            {/* Protected routes */}
            <WhatsAppsProvider>
              <LoggedInLayout>
                <Route exact path="/" component={Dashboard} isPrivate />
                <Route
                  exact
                  path="/tickets/:ticketId?"
                  component={Tickets}
                  isPrivate
                />
                <Route
                  exact
                  path="/connections"
                  component={Connections}
                  isPrivate
                />
                <Route
                  exact
                  path="/clients"
                  component={Clients}
                  isPrivate
                />
                {getSettingValue("storeEnabled") == "enabled" && (
                  <Route
                    exact
                    path="/catalog"
                    component={Catalog}
                    isPrivate
                  />)}
                <Route exact path="/contacts" component={Contacts} isPrivate />
                <Route exact path="/users" component={Users} isPrivate />
                <Route
                  exact
                  path="/quickAnswers"
                  component={QuickAnswers}
                  isPrivate
                />
                <Route exact path="/Settings" component={Settings} isPrivate />
                <Route exact path="/Statistics" component={Statistics} isPrivate />
                <Route exact path="/Queues" component={Queues} isPrivate />
              </LoggedInLayout>
            </WhatsAppsProvider>
          </Switch>
          <ToastContainer autoClose={3000} />
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;